import { getPath, getInitialState } from "../../utils";

const initialState = {
  rolesList: [],
  activeRole: {},
  activeFilters: {},
  allActions: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ROLES_LIST":
      return setRolesList(state, action);
    case "SET_ACTIVE_ROLE":
      return setActiveRole(state, action);
    case "RESET_STATE_ROLES":
      return resetState(state, action);
    case "SET_ACTIVE_FILTERS_ROLES":
      return setFilters(state, action);
    case "SET_ACTIONS_LIST":
      return setActionsList(state, action);
    default:
      return state;
  }
}

const setActiveRole = (state, action) => {
  return {
    ...state,
    activeRole: action.payload,
  };
};

const setFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setActionsList = (state, action) => {
  return {
    ...state,
    allActions: getPath(action.payload, "actions", []),
  };
};

const setRolesList = (state, action) => {
  return {
    ...state,
    rolesList: getPath(action.payload, "roles", []),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
